module.exports = __webpack_public_path__ + "23c40afb3aa7793dcda45bbc5ae3e1c3.png";